<template>
  <el-dialog
    title="批量发送消息"
    :visible.sync="dialogVisible"
    :width="width"
    :before-close="handleClose"
  >
    <div class="bulk-send-container">
      <div class="upload-area" v-if="!fileUploaded">
        <div style="display: flex; flex-direction: column">
          <el-upload
            ref="excelUpload"
            class="upload-excel"
            drag
            action=""
            :auto-upload="false"
            :on-change="handleFileChange"
            :limit="1"
            accept=".xlsx,.xls"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将Excel文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传xlsx/xls文件，文件需包含username和hellostring列
            </div>
          </el-upload>
          <el-button
            @click="downlaodExcel"
            style="margin-top: 10px"
            type="primary"
            >下载模版</el-button
          >
        </div>
      </div>

      <div v-if="fileUploaded" class="data-display">
        <div class="action-buttons">
          <el-button type="primary" icon="el-icon-upload" @click="resetUpload"
            >重新上传</el-button
          >
          <el-button
            type="success"
            icon="el-icon-s-promotion"
            @click="startSendMessages"
            :loading="isSending"
            :disabled="isSending"
            >发送</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-video-pause"
            @click="interruptSending"
            :disabled="!isSending"
            >中断</el-button
          >
          <el-button
            type="info"
            icon="el-icon-video-play"
            @click="continueSending"
            :disabled="!isInterrupted"
            >继续</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-user"
            @click="addAsFriends"
            :loading="isAddingFriends"
            :disabled="isAddingFriends"
            >加好友</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="exportData"
            :disabled="isSending || currentIndex < totalItems"
            >导出结果</el-button
          >
        </div>
        <div class="action-buttons" style="display: flex; align-items: center">
          <span>打招呼模版:</span>
          <el-select
            size="mini"
            v-model="modelText"
            clearable
            placeholder="选择打招呼模版组"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.groupName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button
            v-if="modelText"
            type="primary"
            @click="onUpData"
            size="mini"
            >保存</el-button
          >
        </div>

        <div class="progress-bar" v-if="isSending || isInterrupted">
          <el-progress
            :percentage="progressPercentage"
            :status="
              isInterrupted
                ? 'exception'
                : progressPercentage === 100
                ? 'success'
                : undefined
            "
          ></el-progress>
          <div class="progress-text">{{ progressText }}</div>
        </div>

        <el-table
          :data="tableData"
          style="width: 100%"
          max-height="400"
          border
          v-loading="tableLoading"
        >
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="username"
            label="用户名"
            width="180"
          ></el-table-column>
          <el-table-column prop="hellostring" label="问候语"></el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)">{{
                scope.row.status
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="sendSingleMessage(scope.row)"
                :disabled="isSending || scope.row.status === '发送成功'"
                >发送</el-button
              >
              <el-button
                size="mini"
                type="primary"
                @click="addSingleFriend(scope.row)"
                :disabled="isAddingFriends || scope.row.status === '已加好友'"
                >加好友</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="logs-area">
          <div class="logs-header">
            <h3>发送日志</h3>
            <el-button type="text" @click="clearLogs">清空日志</el-button>
          </div>
          <div class="logs-content" ref="logsContent">
            <div v-for="(log, index) in logs" :key="index" class="log-item">
              <span class="log-time">{{ log.time }}</span>
              <span :class="['log-message', log.type]">{{ log.message }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as XLSX from "xlsx";
import http from "@/api/httpRequest.js";

export default {
  name: "BulkSendMessages",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uid: "",
      time: 120000,
      options: [],
      modelText: null,
      dialogVisible: false,
      fileUploaded: false,
      tableData: [],
      tableLoading: false,
      excelFile: null,
      isSending: false,
      isInterrupted: false,
      isAddingFriends: false,
      currentIndex: 0,
      totalItems: 0,
      logs: [],
      sendTask: null,
      progressPercentage: 0,
      consecutiveFailedCount: 0,
      progressText: "",
      width: "40%",
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    downlaodExcel() {
      const link = document.createElement("a");
      link.href = "/template/template2.xlsx";
      link.download = "批量用户名打招呼模版.xlsx";
      link.click();
    },
    exportData() {
      const worksheet = XLSX.utils.json_to_sheet(this.tableData, {
        header: ["username", "hellostring", "status"],
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "结果日志");
      XLSX.writeFile(workbook, "结果日志.xlsx");
    },
    removeFile() {
      const uploadRef = this.$refs.excelUpload;
      if (uploadRef && typeof uploadRef.clearFiles === "function") {
        uploadRef.clearFiles();
      }
    },
    handleClose() {
      if (this.isSending) {
        this.$confirm("任务正在进行中，确定要关闭吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.interruptSending();
            this.resetData();
            this.dialogVisible = false;
            this.width = "40%";
            this.modelText = null;
            this.removeFile();
          })
          .catch(() => {});
      } else {
        this.resetData();
        this.$emit("close");
        this.dialogVisible = false;
        this.width = "40%";
        this.modelText = null;
        this.removeFile();
      }
    },
    resetData() {
      this.fileUploaded = false;
      this.tableData = [];
      this.excelFile = null;
      this.isSending = false;
      this.isInterrupted = false;
      this.isAddingFriends = false;
      this.currentIndex = 0;
      this.totalItems = 0;
      this.logs = [];
      this.progressPercentage = 0;
      this.progressText = "";
      this.consecutiveFailedCount = 0;
    },
    getGreetList() {
      this.$http.get("/client/greet").then((res) => {
        this.options = res;
      });
    },
    onUpData() {
      const object = this.options.find((item) => {
        return item.id == this.modelText;
      });
      this.tableData.forEach((item) => {
        const randomIndex = Math.floor(
          Math.random() * object.greetInfoList.length
        );
        item.hellostring = object.greetInfoList[randomIndex].content;
      });
    },
    handleFileChange(file) {
      this.tableLoading = true;
      this.excelFile = file.raw;

      if (!this.excelFile) {
        this.$message.error("文件上传失败，请重试");
        this.tableLoading = false;
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          if (jsonData.length === 0) {
            this.$message.error("Excel文件为空或格式不正确");
            this.tableLoading = false;
            return;
          }

          // 检查必要的列
          const firstRow = jsonData[0];
          if (
            !Object.prototype.hasOwnProperty.call(firstRow, "username") ||
            !Object.prototype.hasOwnProperty.call(firstRow, "hellostring")
          ) {
            this.$message.error("Excel文件必须包含username和hellostring列");
            this.tableLoading = false;
            return;
          }

          this.tableData = jsonData.map((row) => ({
            ...row,
            status: "待处理",
          }));
          this.totalItems = this.tableData.length;
          this.fileUploaded = true;
          this.addLog("info", `成功导入${this.totalItems}条数据`);
          this.uid = Date.now();
          this.width = "70%";
          this.getGreetList();
        } catch (error) {
          console.error("解析Excel文件失败", error);
          this.$message.error("解析Excel文件失败，请检查文件格式");
        } finally {
          this.tableLoading = false;
        }
      };
      reader.readAsArrayBuffer(this.excelFile);
    },
    resetUpload() {
      if (this.isSending) {
        this.$message.warning("发送任务进行中，请先中断任务");
        return;
      }
      this.width = "40%";
      this.fileUploaded = false;
      this.tableData = [];
      this.excelFile = null;
      this.currentIndex = 0;
      this.totalItems = 0;
      this.progressPercentage = 0;
      this.progressText = "";
      this.modelText = null;
      this.removeFile();
    },
    startSendMessages() {
      if (this.tableData.length === 0) {
        this.$message.warning("没有可发送的数据");
        return;
      }

      this.isSending = true;
      this.isInterrupted = false;
      this.addLog("info", "开始批量发送消息");
      this.processNextItem();
    },
    interruptSending() {
      if (!this.isSending) return;

      this.isSending = false;
      this.isInterrupted = true;
      clearTimeout(this.sendTask);
      const sentCount = this.tableData.filter(
        (item) => item.status !== "待处理"
      ).length;
      this.progressPercentage =
        this.totalItems > 0
          ? Math.floor((sentCount / this.totalItems) * 100)
          : 0;
      this.addLog(
        "warning",
        `发送任务中断，已处理${sentCount}/${this.totalItems}条`
      );
      this.progressText = `已发送 (${sentCount}/${this.totalItems})`;
    },
    continueSending() {
      if (!this.isInterrupted) return;

      this.isSending = true;
      this.isInterrupted = false;
      this.addLog("info", `继续发送任务，从第${this.currentIndex + 1}条开始`);
      this.processNextItem();
    },
    updateProgress() {
      const sentCount = this.tableData.filter(
        (item) => item.status !== "待处理"
      ).length;
      this.progressPercentage =
        this.totalItems > 0
          ? Math.floor((sentCount / this.totalItems) * 100)
          : 0;
      this.progressText = `已发送 (${sentCount}/${this.totalItems})`;
    },

    async sendMessage(item) {
      return http({
        url: "/client/greetStranger",
        method: "post",
        params: {
          accountId: this.$store.state.cicadeStore.activeAccount.accountId,
          username: item.username,
          greeting: item.hellostring,
          uid: this.uid,
        },
      });
    },
    async sendSingleMessage(row) {
      if (this.isSending) return;
      const account = this.$store.state.cicadeStore.activeAccount;
      const accountName = account.account || account.accountName;
      try {
        this.$set(row, "status", "发送中...");
        await this.sendMessage(row);
        this.$set(row, "status", "发送成功");
        this.addLog(
          "success",
          `账号:${accountName}成功发送消息给 ${row.username}`
        );
      } catch (error) {
        this.$set(row, "status", "发送失败");
        this.addLog(
          "error",
          `账号:${accountName}发送消息给 ${row.username} 失败: ${
            error.message || "未知错误"
          }`
        );
      } finally {
        this.updateProgress();
      }
    },
    async processNextItem() {
      if (!this.isSending || this.currentIndex >= this.tableData.length) {
        if (this.isSending) {
          this.isSending = false;
          this.addLog("success", "所有消息发送完成");
          this.updateProgress();
          this.progressText = `发送完成 (${this.totalItems}/${this.totalItems})`;
        }
        return;
      }

      const item = this.tableData[this.currentIndex];
      const account = this.$store.state.cicadeStore.activeAccount;

      if (item.status !== "发送成功" && item.status !== "发送失败") {
        try {
          item.accountName = account.account || account.accountName;
          await this.sendMessage(item);
          this.$set(item, "status", "发送成功");
          this.consecutiveFailedCount = 0;
          this.addLog(
            "success",
            `账号:${item.accountName}成功发送消息给 ${item.username}`
          );
        } catch (error) {
          this.$set(item, "status", "发送失败");
          this.consecutiveFailedCount++;
          if (this.consecutiveFailedCount >= 3) {
            this.addLog("error", "连续多条数据都失败，任务已中断！");
            this.interruptSending();
            this.$confirm(
              "任务已中断，可以导出结果查看发送失败和待发送数据。",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            );
            return;
          }
          this.addLog(
            "error",
            `账号:${item.accountName}发送消息给 ${item.username} 失败: ${
              error.message || "未知错误"
            }`
          );
        }
      }

      this.currentIndex++;
      this.updateProgress();
      this.sendTask = setTimeout(() => {
        this.processNextItem();
      }, this.time);
    },
    async addAsFriends() {
      if (this.isAddingFriends) return;

      const selection = this.$refs.table
        ? this.$refs.table.selection
        : this.tableData;
      if (selection.length === 0) {
        this.$message.warning("请选择要添加的用户");
        return;
      }

      this.isAddingFriends = true;
      this.addLog("info", `开始批量添加好友，共${selection.length}个用户`);

      for (let i = 0; i < selection.length; i++) {
        const item = selection[i];
        try {
          await this.addFriend(item);
          this.$set(item, "status", "已加好友");
          this.addLog("success", `成功添加 ${item.username} 为好友`);
        } catch (error) {
          this.addLog(
            "error",
            `添加 ${item.username} 为好友失败: ${error.message || "未知错误"}`
          );
        }
      }

      this.isAddingFriends = false;
      this.addLog("info", "批量添加好友完成");
    },
    async addSingleFriend(row) {
      if (this.isAddingFriends) return;

      try {
        this.$set(row, "status", "添加中...");
        await this.addFriend(row);
        this.$set(row, "status", "已加好友");
        this.addLog("success", `成功添加 ${row.username} 为好友`);
      } catch (error) {
        this.$set(row, "status", "添加失败");
        this.addLog(
          "error",
          `添加 ${row.username} 为好友失败: ${error.message || "未知错误"}`
        );
      }
    },
    async addFriend(item) {
      // 调用添加好友接口
      return http({
        url: "/client/addFriend",
        method: "post",
        params: {
          accountId: this.$store.state.cicadeStore.activeAccount.accountId,
          username: item.username,
        },
      });
    },
    addLog(type, message) {
      const time = new Date().toLocaleTimeString();
      this.logs.push({ time, type, message });
      this.$nextTick(() => {
        if (this.$refs.logsContent) {
          this.$refs.logsContent.scrollTop =
            this.$refs.logsContent.scrollHeight;
        }
      });
    },
    clearLogs() {
      this.logs = [];
    },
    getStatusType(status) {
      switch (status) {
        case "发送成功":
        case "已加好友":
          return "success";
        case "发送失败":
        case "添加失败":
          return "danger";
        case "发送中...":
        case "添加中...":
          return "warning";
        default:
          return "info";
      }
    },
  },
};
</script>

<style scoped>
.bulk-send-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.action-buttons {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}

.progress-bar {
  margin-bottom: 15px;
}

.progress-text {
  margin-top: 5px;
  text-align: center;
  color: #606266;
}

.logs-area {
  margin-top: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.logs-header {
  padding: 8px 15px;
  border-bottom: 1px solid #e4e7ed;
  background-color: #f5f7fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logs-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.logs-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 150px;
  overflow-y: auto;
  padding: 10px 15px;
  background-color: #fafafa;
}

.log-item {
  padding: 4px 0;
}

.log-time {
  color: #909399;
  margin-right: 8px;
}

.log-message {
  word-break: break-word;
}

.log-message.success {
  color: #67c23a;
}

.log-message.error {
  color: #f56c6c;
}

.log-message.warning {
  color: #e6a23c;
}

.log-message.info {
  color: #409eff;
}
</style>
